<template>
    <div>
      <div class="mb-4">
        <h2 class="text-base font-semibold text-gray-800">Query &amp; Rejection Response Templates</h2>
        <p class="text-sm text-gray-500 mt-1">Manage the standard response messages used when querying or rejecting
          applications. These templates are presented to applicants as the reason for the query or rejection.</p>
      </div>

      <div class="grid grid-cols-12 gap-4">
            <AppModal v-model="showAddWord" hide-footer title="Add Rejection/Query reason template">
                <div class="col-span-12">
                  <form class="w-full space-y-3">
                        <input
                          type="text"
                          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
                          v-model="form.reason"
                          placeholder="Reason"
                          required
                        />
                        <textarea
                          v-model="form.message"
                          type="text"
                          placeholder="Response message "
                          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
                          rows="4"
                          required
                        ></textarea>

                    <select v-model="form.appealStatus"
                            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary">
                      <option v-for="option in positionList" :key="String(option.value ?? '')" :value="option.value">
                        {{ option.text }}
                      </option>
                        </select>

                    <div class="flex justify-end">
                            <button
                              type="button"
                              @click="saveWord"
                              class="btn-primary">
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </AppModal>
        </div>
        <div class="grid grid-cols-12 gap-4">
            <AppModal v-model="showEditWord" hide-footer title="Edit Word">
                <div class="col-span-12">
                  <form class="w-full space-y-3">
                        <input
                          type="text"
                          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
                          v-model="eform.reason"
                          placeholder="Reason"
                          required
                        />
                        <textarea
                          v-model="eform.message"
                          type="text"
                          placeholder="Message "
                          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
                          rows="4"
                          required
                        ></textarea>

                    <select v-model="eform.appealStatus"
                            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary">
                      <option v-for="option in positionList" :key="String(option.value ?? '')" :value="option.value">
                        {{ option.text }}
                      </option>
                        </select>

                        <p class="text-sm mt-3 italic text-blue">
                            This action will be logged and your account flagged as one who took this action and also had
                            the
                            permission to do so.
                        </p>

                    <div class="flex justify-end">
                            <button
                              type="button"
                              @click="updateWord"
                              class="btn-primary">
                                Save Changes
                            </button>
                        </div>
                    </form>
                </div>
            </AppModal>
        </div>
        <div class="grid grid-cols-12 gap-4">
            <AppModal v-model="showDeleteWord" hide-footer title="Remove Word">
                <div class="col-span-12">
                    <form class="w-full">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12">
                                <p class="text-center">
                                    Are you sure you want to remove this response <b>{{ dform.word.toUpperCase() }}</b>
                                    from
                                    the database?<br/><br/>
                                    Removing this word means that it will no longer be used and considered as a
                                    response during query/response to the client.
                                </p>
                                <p class="text-sm mt-3 italic text-red">
                                    This action will be logged and your account flagged as one who took this action and
                                    also had the
                                    permission to do so.
                                </p>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-4"></div>
                            <div class="col-span-4 text-center justify-content-center">
                                <button
                                  type="button"
                                  @click="removeWord"
                                  class="btn-sm-danger w-full mt-3">
                                    Yes
                                </button>
                            </div>
                            <div class="col-span-4"></div>
                        </div>
                    </form>
                </div>
            </AppModal>
        </div>
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 mb-4">
                <div class="grid grid-cols-12 gap-4 mx-1">
                    <div class="col-span-2">
                        <button
                                v-b-modal.modal-add-word
                                class="btn-primary w-full">
                          <i class="fa fa-plus"></i>
                            Add Response
                        </button>
                    </div>
                    <div class="col-span-2">

                    </div>
                    <div class="col-span-6"></div>
                    <div class="col-span-2">
                        <input
                          type="text"
                          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
                          placeholder="Search"
                          required
                          v-on:keyup.enter="searchDictionary()">
                        </input>
                    </div>
                </div>
            </div>

        </div>

        <div class="mx-auto" v-if="loading">
            <div class="w-full bg-gray-200 rounded-full h-1 overflow-hidden">
                <div class="bg-primary h-full animate-pulse" style="width: 100%"></div>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-4 mx-auto">
            <div class="col-span-12">
                <table class="w-full leading-normal">
                    <thead>
                    <tr class="border-b border-t border-gray-200">
                        <th class="t-header">#</th>
                        <th class="t-header">Reason</th>
                        <th class="t-header">Message</th>
                        <th class="t-header">Allow Appeal</th>
                        <th v-if="canEditWord()" class="t-header">Edit</th>
                        <th v-if="canDeleteWord()" class="t-header">Remove</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(page, idx) in wordList"
                        :key="idx">
                        <td class="t-body">{{ idx + 1 }}</td>
                        <td class="t-body font-bold">{{ page.reason }}</td>
                        <td class="t-body">{{ page.message }}</td>
                        <td class="t-body">{{ page.appealStatus ? 'Yes' : 'No' }}</td>
                        <td v-if="canEditWord()" class="t-body">
                          <button @click="editWordPrompt(page)" class="btn-sm-primary">
                              <i class="fa fa-pencil mr-1"></i>Edit
                            </button>
                        </td>
                        <td v-if="canDeleteWord()" class="t-body">
                          <button @click="deleteWordPrompt(page)" class="btn-sm-danger">
                              <i class="fa fa-ban mr-1"></i> De-activate
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td v-if="wordList.length === 0" colspan="8" class="bg-inertgrey text-center py-1">
                            <span class="text-sm">No results found</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref, watch } from "vue";
import { useConfigurationsStore } from "../../stores";
import AppModal from "@/components/ui/AppModal.vue";

interface WordForm {
  reason: string | null;
  message: string | null;
  appealStatus: boolean | null;
}

interface DeleteForm {
  id: string | null;
  word: string;
}

interface GlobalProperties {
  $can?: (permission: string, group: string) => boolean;
  successToast?: (title: string, message: string) => void;
  errorToast?: (title: string, message: string) => void;
}

const store = useConfigurationsStore();
const instance = getCurrentInstance();
const proxy = instance?.proxy as unknown as GlobalProperties | undefined;

const showAddWord = ref(false);
const showEditWord = ref(false);
const showDeleteWord = ref(false);
const loading = ref(true);
const wordList = ref<any[]>([]);
const selectedId = ref<string | null>(null);

const positionList = ref([
  { text: "--Allow appeal--", id: null },
  { value: true, text: "Yes" },
  { value: false, text: "No" }
]);

const form = ref<WordForm>({
  reason: null,
  message: null,
  appealStatus: null
});

const eform = ref<WordForm>({
  reason: null,
  message: null,
  appealStatus: null
});

const dform = ref<DeleteForm>({
  id: null,
  word: ""
});

const rows = ref({
  odd: "border-t border-gray-200 hover:bg-gray-10",
  even: "border-t border-gray-200 bg-gray-10"
});

onMounted(() => {
  store.fetchQueryRejectionWords();
});

const editWordPrompt = (data: any) => {
  selectedId.value = data.id;
  eform.value = {
    message: data.message,
    appealStatus: data.appealStatus,
    reason: data.reason
  };
  showEditWord.value = true;
};

const deleteWordPrompt = (data: any) => {
  dform.value = {
    id: data.id,
    word: data.reason
  };
  showDeleteWord.value = true;
};

const saveWord = () => {
  loading.value = true;
  store.addRejectionQueryWord(form.value);
};

const updateWord = () => {
  loading.value = true;
  store.editRejectionQueryWord(eform.value);
};

const removeWord = () => {
  loading.value = true;
  store.deleteRejectionQueryWord(dform.value);
};

const searchDictionary = () => {
  store.fetchQueryRejectionWords();
};

const canEditWord = () => {
  return proxy?.$can?.("can_edit_dictionary_entry", "general") ?? false;
};

const canDeleteWord = () => {
  return proxy?.$can?.("can_delete_dictionary_entry", "general") ?? false;
};

watch(
  () => store.rejectionWords,
  (data) => {
    loading.value = false;
    wordList.value = [];
    wordList.value = data;
  }
);

watch(
  () => store.rejectionSuccess,
  (data) => {
    store.fetchQueryRejectionWords();
    showAddWord.value = false;
    showEditWord.value = false;
    showDeleteWord.value = false;

    form.value = {
      reason: null,
      message: null,
      appealStatus: null
    };

    proxy?.successToast?.("Success", data.message);
  }
)

watch(
  () => store.rejectionError,
  (message) => {
    loading.value = false;
    proxy?.errorToast?.("Error", message.data.message);
  }
);
</script>

